const fileDownloadButtonTreeNode = {
  title: 'Generar qrcode para esta rama',
  cutOut: 'Recortar',
  paste: 'Pegar'
};

export default fileDownloadButtonTreeNode;
